import { graphql } from "@/graphql/codegen"

graphql(`
  fragment VendorApLedgerEntryFields on VendorApLedgerEntry {
    vendorApLedgerEntryId
    glTransactionReferenceNumber
    transactionDate
    invoiceAction
    type
    amount
    apBalance
    invoice {
      invoiceId
      invoiceNumber
      referenceNumber
      hasDocuments
    }
  }
`)
